import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import {HiHome,HiOutlineUserGroup,HiUserAdd} from 'react-icons/hi';
import { Alert } from 'flowbite-react'; 
import api from '../../../services/api/axiosConfig';
import PageHeading from '../../../components/PageHeading';
import errorHandler from '../../../utils/errorHandler';
import CustomerForm from '../components/CustomerForm';
import Breadcrumb from '../../dashboard/pages/components/BreadCrumb';
import customerValidation from "../utils/customerValidation";
import { initialCustomerData } from '../data/customerModel';
import API_ENDPOINTS from '../../../services/api/endpoints';
import { toast } from 'react-toastify';

const CreateCustomerPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState(initialCustomerData);

    const breadcrumbItems = [
        { label: 'Dashboard', url: '/dashboard' },
        { label: 'Customers', url: '/dashboard/customer-list' },
        { label: 'Create Customer', url: '#', current: true } // Mark as current page
    ];

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [generalError, setGeneralError] = useState(null); // For general API errors not tied to a specific field
    const [successMessage, setSuccessMessage] = useState(null); // For success messages

    useEffect(() => {
        document.title = 'CPA - Create Customer';
        // You might want to verify user authentication here as well
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            navigate('/');
        }
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear specific field error as user types
        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
        // Clear general error/success when user types
        setGeneralError(null);
        setSuccessMessage(null);
    };

    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({}); // Clear field errors
        setGeneralError(null); // Clear general error
        setSuccessMessage(null); // Clear success message

        const validationErrors = customerValidation(formData);
        
        console.log("frontend validation error ",validationErrors);
        if (Object.keys(validationErrors).length === 0) {


            try {
                const payload = {
                    ...formData,
                    // Strip all non-numeric characters from the phone number
                    phone: formData.phone.replace(/\D/g, ''),

                };
                // that expects this data and uses the stored procedure.
                const response = await api.post(API_ENDPOINTS.PANEL.CUSTOMER.CREATE, payload);

                
                if (response.data.statuscode==212) {
                    errorHandler(response.data, setErrors);
                } else {
                    console.log('Customer created successfully:', response.data);
                    toast.success("Customer created successfully");
                    setFormData(initialCustomerData);
                    navigate('/dashboard/customer-list') 
                }

               
            } catch (error) {
                console.error('Failed to create customer:', error);
                errorHandler(error, setErrors);

            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false); // Stop loading if client-side validation fails
            
            // Update the state with the errors returned by the function
            setErrors(validationErrors);
            toast.error("Please fix the validation errors before submitting.")
        }
    };


    return (
        <div className="p-4 sm:p-6 lg:p-8">
            {generalError && (
                <Alert color="failure" onDismiss={() => setGeneralError(null)} className="mb-4">
                    <span className="font-medium">Error!</span> {generalError}
                </Alert>
            )}
            {successMessage && (
                <Alert color="success" onDismiss={() => setSuccessMessage(null)} className="mb-4">
                    <span className="font-medium">Success!</span> {successMessage}
                </Alert>
            )}


            <Breadcrumb items={breadcrumbItems} />

            <PageHeading value="Create New Customer" />

            <CustomerForm
                formData={formData}
                handleChange={handleChange}
                errors={errors} // Pass the entire errors object
                loading={loading}
                handleSubmit={handleSubmit}
                submitButtonText="Create Customer"
                submitButtonTextSubmitting="Creating Customer..."

            />
        </div>
    );
};

export default CreateCustomerPage;

